// extracted by mini-css-extract-plugin
module.exports = {"root":"MergedInvoice_root__1Hzjl","header":"MergedInvoice_header__1Jckz"};